<template>
  <div class="pt-8 md:pt-16 px-8 md:px-16 flex flex-wrap justify-between items-baseline">
    <RouterLink
      :to="{
        name: 'home'
      }"
    >
      <img
        class="h-12 md:h-16 object-contain"
        :src="require('@assets/img/logo.jpg')"
      >
    </RouterLink>
    <h2
      v-show="$route.name === 'home'"
      class="text-4 md:text-3 leading-tight mt-8"
      v-text="strapline"
    />
  </div>
</template>

<script>
import { global } from '@io';

export default {
  name: 'BlockHeader',

  data: () => ({
    strapline: '',
  }),

  async mounted() {
    // Get data
    this.strapline = await global.get('strapline');
  },
};
</script>
